import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useTranslation } from "react-i18next";

export default function ReactiveEnergyPie({ importVal = 0, exportVal = 0 }) {
    const { t } = useTranslation();
    const realImport = Math.trunc((importVal || 0) * 1000) / 1000;
    const realExport = Math.trunc((exportVal || 0) * 1000) / 1000;


    const drawImport = realImport > 0 ? realImport : 0.001;
    const drawExport = realExport > 0 ? realExport : 0.001;

    const data = [
        { name: t('dashboard.importReactive'), value: drawImport },
        { name: t('dashboard.exportReactive'), value: drawExport },
    ];

    const COLORS = ["#3B82F6", "#EF4444"];

    return (
        <div className="bg-white border rounded-xl shadow p-5">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.reactiveEnergyDist')}
            </h3>

            <div className="flex items-center justify-center h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie data={data} cx="50%" cy="50%" outerRadius={100} dataKey="value">
                            {data.map((_, i) => (
                                <Cell key={i} fill={COLORS[i]} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(v) => `${Number(v).toFixed(3)} kVArh`} />
                        <Legend
                            layout="horizontal"
                            align="center"
                            verticalAlign="bottom"
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
